<template>
  <v-expansion-panel
    v-model="expansionPanel"
    class="v-expansion-panel_inlined"
  >
    <v-expansion-panel-content>
      <template slot="header">
        <v-layout align-center>
          <baseIcon
            :width="36"
            :height="36"
            class="mr-3"
          >
            <volunteersIcon :icon-color="$vuetify.theme.sz_medium_grey" />
          </baseIcon>
          {{ $t('family_card.accordion_titles.volunteers') }}
        </v-layout>
      </template>
      <v-card>
        <v-divider />
        <v-layout
          class="mt-4 align-stretch volunteers"
          :wrap="$vuetify.breakpoint.mdAndDown"
        >
          <v-flex
            v-if="!isSupporting"
            md6
            xs12
          >
            <h4 class="display-1 display-1_dark mb-2 d-inline-block">
              {{ $t('warehouses.warehouse_manager.lider') }}
            </h4>
            <v-flex
              v-for="(leader, index) in leadersList"
              :key="index"
              class="mb-2"
            >
              <p class="mb-0">
                {{ leader.full_name }}
              </p>
              <p class="mb-0">
                {{ leader.email }}
              </p>
              <p class="mb-0">
                {{ leader.phone | phone }}
              </p>
            </v-flex>
          </v-flex>
          <v-flex
            md6
            xs12
          >
            <h4 class="display-1 display-1_dark mb-2 d-inline-block">
              {{ $t('warehouses.warehouse_manager.title_short') }}
            </h4>
            <p class="mb-0">
              {{ warehouseManager.full_name }}
            </p>
            <p class="mb-0">
              {{ warehouseManager.email }}
            </p>
            <p class="mb-0">
              {{ warehouseManagerPhone | phone }}
            </p>
          </v-flex>
        </v-layout>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import baseIcon from '@/icons/BaseIcon';
import volunteersIcon from '@/icons/VolunteersIcon';
import filters from '@/constants/filters';

export default {
    name: 'WarehouseVolunteersData',
    components: { baseIcon, volunteersIcon },
    filters: {
        ...filters
    },
    props: {
        isSupporting: {
            default: false,
            type: Boolean
        },
        warehouseManager: {
            default: null
        },
        leadersList: {
            default: () => {
                return {};
            }
        },
        warehouseManagerPhone: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            expansionPanel: 0
        };
    }
};
</script>

<style scoped></style>
